/* eslint-disable max-len */

import {
  createHeading,
  createRowFileUploadField,
  createRowMultiSelectField,
  createRowSelectField,
  createRowWysiwygField,
  createSelectField,
  createTableQuestion
} from '../../../Utils/questionHelper';

import {
  CDP_SHARE_YES_NO_OPTIONS,
  ENVIRONMENTAL_ISSUES_OPTIONS,
  OTHER_ENVIRONMENTAL_INFO_VERIFICATION_OPTIONS,
  PRIMARY_REASONS_FOR_NOT_ASSESSING_INTERCONNECTIONS_OPTIONS,
  SIGN_OFF_JOB_TITLE_OPTIONS,
  THIRD_PARTY_VERIFICATION_DATA_POINTS_OPTIONS,
  VERIFICATION_STANDARDS_OPTIONS
} from './corporateOptions';
import {CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS} from './corporateQuestionsKeys';

export const furtherInformationAndSignOffQuestions = [
  {
    key: 'Q1',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS.Q1_VALUE,
        '13.1 Indicate if any environmental information included in your CDP response (not already reported in 7.9.1/2/3, 8.9.1/2/3/4, and 9.3.2) is verified and/or assured by a third party?',
        'This information gives data users confidence in the quality and credibility of your organization’s response. CDP supports third-party verification and assurance as good practice in environmental reporting as it ensures the reliability of the data and processes disclosed. This question allows leading organizations to report their efforts on this and to highlight trends in verification and assurance of interest to investors and purchasing organizations. CDP also recognizes the growing importance to organizations of disclosing credible independently verified environmental data for demonstrating compliance with emerging standards and regulations.',
        [
          createRowSelectField(
            CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS.Q1_1_VALUE,
            'Other environmental information included in your CDP response is verified and/or assured by a third party',
            OTHER_ENVIRONMENTAL_INFO_VERIFICATION_OPTIONS
          ),
          createRowSelectField(
            CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS.Q1_2_VALUE,
            'Primary reason why other environmental information included in your CDP response is not verified and/or assured by a third party',
            PRIMARY_REASONS_FOR_NOT_ASSESSING_INTERCONNECTIONS_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS.Q1_3_VALUE,
            'Explain why other environmental information included in your CDP response is not verified and/or assured by a third party',
            2000
          )
        ]
      )
    ]
  },
  {
    key: 'Q2',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS.Q2_VALUE,
        '13.1.1 Which data points within your CDP response are verified and/or assured by a third party, and which standards were used?',
        'This question only appears if you select “Yes” or “Third-party verification/assurance is currently in progress” in response to column “Other environmental information included in your CDP response is verified by a third party” of 13.1. No change This information allows data users to understand which elements of your organizations CDP response have been verified/assured by an accredited third-party.',
        [
          createRowMultiSelectField(
            CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS.Q2_1_VALUE,
            'Environmental issue for which data has been verified and/or assured',
            ENVIRONMENTAL_ISSUES_OPTIONS
          ),
          createRowSelectField(
            CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS.Q2_2_VALUE,
            'Disclosure module and data verified and/or assured',
            THIRD_PARTY_VERIFICATION_DATA_POINTS_OPTIONS
          ),
          createRowSelectField(
            CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS.Q2_3_VALUE,
            'Verification/assurance standard',
            VERIFICATION_STANDARDS_OPTIONS
          ),
          createRowWysiwygField(
            CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS.Q2_4_VALUE,
            'Further details of the third-party verification/assurance process',
            2000
          ),
          createRowWysiwygField(
            CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS.Q2_5_VALUE,
            'Attach verification/assurance evidence/report (optional)',
            2000
          )
        ],
        true,
        CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS.Q1_VALUE,
        CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS.Q1_1_VALUE,
        ['Yes', 'Third-party verification/assurance is currently in progress']
      )
    ]
  },
  {
    key: 'Q3',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS.Q3_VALUE,
        `13.2 Use this field to provide any additional information or context that you feel is relevant to your ${'organization'}'s response. Please note that this field is optional and is not scored.`,
        '',
        [
          createRowWysiwygField(
            CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS.Q3_1_VALUE,
            'Additional information',
            10000
          ),
          createRowFileUploadField(
            CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS.Q3_2_VALUE,
            'Attachment (optional)'
          )
        ]
      )
    ]
  },
  {
    key: 'Q4',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS.Q4_VALUE,
        '13.3 Provide the following information for the person that has signed off (approved) your CDP response.',
        'CDP asks organizations to identify the job title and corresponding job category of the person signing off (approving) the CDP response. This information indicates to investors where in the corporate structure direct responsibility is being taken for the response and the information contained therein.',
        [
          createRowWysiwygField(
            CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS.Q4_1_VALUE,
            'Job title',
            200
          ),
          createRowSelectField(
            CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS.Q4_2_VALUE,
            'Corresponding job category',
            SIGN_OFF_JOB_TITLE_OPTIONS
          )
        ]
      )
    ]
  },
  {
    key: 'Q5',
    showIndex: false,
    items: [
      {
        field: [
          createHeading(
            '13.4 Please indicate your consent for CDP to share contact details with the Pacific Institute to support content for its Water Action Hub website',
            'The CEO Water Mandate Water Action Hub is an online platform that catalogues water stewardship projects around the world and enables interested parties to connect and work together to solve local and regional water challenges. CDP will share public response data from 3.1.1 with the Pacific Institute to be reviewed as potential water stewardship projects for upload to the Water Action Hub website. Only responses to the following datapoints will be considered for upload: For the Water environmental issue: Country/Area where the risk occurs; River basin where the risk occurs; Primary response to risk; Description of response. CDP’s Privacy Policy can be found here.'
          ),
          createSelectField(
            CDP_FURTHER_INFORMATION_AND_SIGN_OFF_KEYS.Q5_VALUE,
            '',
            CDP_SHARE_YES_NO_OPTIONS
          )
        ]
      }
    ]
  }
];
